<template>
    <div class="container">
        <div class="content" >
            <div class="data-title">
                <div style="display: flex;height: 32px;">
                    <div class="title-line"></div>
                    <div class="title-name">审批流程交接</div>
                </div>

                <div class="title-btn">
                    <div class="title-btn-item" @click="openAdiog">
                        <i class="el-icon-plus"></i>
                        <div class="btn-l">发起新交接</div>
                    </div>
                </div>
            </div>
            <lb-table :column="column" :data="tableList" pagination :total="page.totalNum" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
                :current-page.sync="page.currentPage" :page-size="page.pageSize" @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
            </lb-table>
        </div>

        <!-- 发起新交接弹窗 -->
        <el-dialog :visible.sync="dialogFormVisible" :append-to-body="true" title="发起新交接" width="600px" class="pop-handover">
            <el-form :model="form" :rules="rules" ref="form" size="small" class="elForm" label-position="top">
                <el-form-item label-width="100px" label="把审批流程交接出去的人（被交接人）" prop="person1">
                    <el-select v-model="person1" @click.native="openUserPicker('person1')" key="main" value-key="name"
                                class="select-u" placeholder="请选择被交接人" collapse-tags
                                size="medium" multiple popper-class="hidden">
                        <el-option v-for="(person, index) in person1" :label="person.serial+' '+person.name" :key="index" :value="person"></el-option>
                    </el-select>
                    <!-- {{ person1 }} -->
                </el-form-item>
                 <el-form-item label-width="100px" label="接收审批流程的人（交接人）" prop="person2" v-if="form.person1">
                    <el-select v-model="person2" @click.native="openUserPicker('person2')" key="main" value-key="name"
                                class="select-u" placeholder="请选择交接人" collapse-tags
                                size="medium" multiple popper-class="hidden">
                        <el-option v-for="(person, index) in person2" :label="person.serial+' '+person.name" :key="index" :value="person"></el-option>
                    </el-select>
                    <!-- {{ person2 }} -->
                </el-form-item>
                 <el-form-item label-width="100px" label="生效审批模板" prop="templateIds" v-if="form.person2">
                    <div v-if="templateNames" class="select-wrap" @click="onFlow('add')">
                        <div class="select-names">{{ templateNames }}</div>
                        <i class="icon-down el-select__caret el-input__icon el-icon-arrow-down"></i>
                    </div>
                    <el-select v-else :value="form.templateIds" @click.native="onFlow('add')"  size="medium"  popper-class="hidden"
                                class="select-all" placeholder="请选择审批模版">
                    </el-select>
                    <div class="tips">选中的审批模板中，“被交接人”的审批节点替换为“交接人”</div>
                </el-form-item>
                
            </el-form>
            <!-- {{ form }} -->
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" :loading="btnloading" @click="subForm">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 模版弹窗 -->
         <el-dialog :visible.sync="dialogFlowVisible" :append-to-body="true" title="审批模版" width="800px" class="pop-handover">
            <div :class="'flow-form flow-form-'+dialogType">
                <div class="flow-1">
                    <div class="flow-head">审批单</div>
                    <!-- {{ lookDetail.approvalForms }} -->
                    <div v-if="dialogType=='look'" class="flow-list" >
                        <template v-if="lookDetail.approvalForms.length > 0">
                            <div v-for="(item,index) of lookDetail.approvalForms" :key="index">
                                <div class="group-name ellipsis">{{ item.groupName }}</div>
                                <div class="group-con" >
                                    <div v-for="(template,index) of item.templates" :key="index" class="item-name ellipsis">{{ template.name }}</div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            无
                        </template>
                    </div>
                    <div v-else-if="dialogType=='add'" class="flow-tree">
                        <el-tree
                            ref="approvalFormsTree"
                            empty-text="该用户没有相关审批单"
                            :data="approvalForms"
                            show-checkbox
                            node-key="id"
                            :default-checked-keys="approvalFormsIds"
                            :default-expand-all="true">
                        </el-tree>
                    </div>
                </div>
                <div class="flow-2">
                    <div class="flow-head">审批流</div>
                    <div v-if="dialogType === 'look'" class="flow-list">
                        <template v-if="lookDetail.approvalFlows.length > 0">
                            <div v-for="(item,index) of lookDetail.approvalFlows" :key="index">
                                <div class="group-name ellipsis">{{ item.groupName }}</div>
                                <div class="group-con" >
                                    <div v-for="(template,index) of item.templates" :key="index" class="item-name ellipsis">{{ template.name }}</div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            无
                        </template>
                    </div>
                    <div v-else-if="dialogType === 'add'" class="flow-tree">
                        <el-tree
                            ref="approvalFlowsTree"
                            empty-text="该用户没有相关审批流"
                            :data="approvalFlows"
                            show-checkbox
                            node-key="id"
                            :default-checked-keys="approvalFlowsIds"
                            :default-expand-all="true">
                        </el-tree>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFlowVisible = false">取 消</el-button>
                <el-button v-if="dialogType==='add'" type="primary" @click="update">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 成员弹窗 -->
        <org-picker title="选择成员" :multiple="false" ref="orgPicker" @ok="selectedUser" />
        
    </div>
</template>

<script>
import LbTable from '../../components/lb-table/lb-table'
import OrgPicker from "@/components/OrgPicker";
export default {
    name: 'processHandover',
    components: {
        LbTable,OrgPicker
    },
    data() {
        // 自定义校验规则：检查两个用户是否相同
        const validateDifferentUsers = (rule, value, callback) => {
            const thisField = rule.field === 'person1' ? this.form.person1 : this.form.person2;
            const otherField = rule.field === 'person1' ? this.form.person2 : this.form.person1;
            // 如果当前字段或另一个字段为空，跳过校验（必填校验会处理）
            if (!value || value.length === 0 || !otherField || otherField.length === 0) {
                callback();
                return;
            }
            const hasSameUser = thisField == otherField;
            if (hasSameUser) {
                callback(new Error('被交接人和交接人不能是同一个人'));
            } else {
                callback();
            }
        };
        
        return {
            column: [
                {
                    type: 'index',
                    label: '序号',
                    width: 80,
                },
                {
                    label: '被交接人',
                    minWidth: 190,
                    render: (h, scope) => {
                        return (
                            <div>{scope.row.fromUserName}</div>
                        )
                    }
                },
                {
                    label: '交接人',
                    minWidth: 190,
                    render: (h, scope) => {
                        return (
                            <div>{scope.row.toUserName}</div>
                        )
                    }
                },
                 {
                    label: '交接审批模版',
                    minWidth: 170,
                    render: (h, scope) => {
                        return (
                            <span style="color:#00B498;cursor:pointer;" onClick={() => { this.onFlow('look',scope.row) }}>{scope.row.templateCount}个模版</span>
                        )
                    }
                },
                {
                    label: '操作人',
                    minWidth: 190,
                    render: (h, scope) => {
                        return (
                            <div>{scope.row.operatorName}</div>
                        )
                    }
                },
                {
                    label: '操作时间',
                    prop: 'transferTime',
                    minWidth: 170
                },
            ],

            rules: {
                 person1: [
                    { required: true, message: '请选择成员', trigger:  ['blur','change'] },
                ],
                person2: [
                    { required: true, message: '请选择成员', trigger:  ['blur','change'] },
                    { validator: validateDifferentUsers, trigger: ['blur', 'change'] }
                ],
                templateIds: [
                    { required: true, message: '请选择生效审批模板', trigger:  ['blur','change'] }
                ],
            },
            tableList:[],
            page: {
                pageNo: 1,
                pageSize: 10,
                totalNum: 0,
                currentPage: 1,
            },

            parArray: [], // 按钮权限
            dialogFormVisible: false,
            btnloading: false,
            form: {
                person1: "",
                person2: "",
                templateIds:[]
            },
            person1:[],
            person2:[],
            personType:'',
            dialogFlowVisible:false,
            dialogType:'',
            lookDetail:{
                approvalForms:[],
                approvalFlows:[],
            },
            approvalForms:[],
            approvalFlows:[],
            approvalFormsIds:[],    // 已选中的审批单
            approvalFlowsIds:[],    // 已选中的审批流
            templateNames:''
        };
    },
    activated() {
        this.fetchData()
    },
    methods: {
        // 打开模版
        onFlow(type,item){
            
             this.dialogType = type
            if(type =='look'){
                this.lookDetail.approvalForms = item.approvalForms || []
                if (item.approvalFlows && item.approvalFlows.length > 0) {
                    this.lookDetail.approvalFlows = [
                        {
                           groupId:'L'+1,
                            groupName:'审批流',
                            templates:item.approvalFlows
                        }
                    ]
                }else{
                   this.lookDetail.approvalFlows = [] 
                }
                this.dialogFlowVisible = true
            }else{
                let params = {
                    userId:this.form.person1
                }
                console.log('>>',params)
                this.$api.workflowApproval(params).then((res) => {
                    if (res.code === 0) {
                        const {approvalForms, approvalFlows} = res.data;
                        const approvalFormsNew = approvalForms
                            .map(e => {
                                if (e.templates && e.templates.length === 0) {
                                    return null; // 标记为空，后续过滤掉
                                }
                                const children = e.templates.map(item => ({
                                    id: item.id,
                                    label: item.templateName,
                                    groupId:e.groupId,
                                    groupName:e.groupName
                                }));
                                return {
                                    label: e.groupName,
                                    id: 'G'+e.groupId,
                                    children: children
                                };
                            })
                            .filter(group => group !== null); // 过滤掉空组
                        this.approvalForms = approvalFormsNew;
                        
                        const approvalFlowsNews = approvalFlows.map(item => ({
                            id: item.id,
                            label: item.templateName,
                            groupId:'L'+1,
                            groupName:'审批流'
                        }));
                        this.approvalFlows = approvalFlows.length > 0 ? [
                            {
                                id:'L'+1,
                                label:'审批流',
                                children:approvalFlowsNews
                            }
                        ] : [];
                        this.dialogFlowVisible = true;
                    }
                });
            }

        },
         // 打开用户选择
        openUserPicker(type) {
            this.personType = type
            let selectedUsers
            if (type === 'person1') {
                // 选择成员+离职
                selectedUsers = this.person1;
                this.$refs.orgPicker.show(selectedUsers, 'resign');
            } else if (type === 'person2') {
                // 选择成员
                selectedUsers = this.person2;
                this.$refs.orgPicker.show(selectedUsers, 'user');
            }
            
        },
        //用户选择回调
        selectedUser(data) {
            console.log('$on:',data)
            if (data.length==0) return false
            let newPersonId = data[0].id
            if (this.personType === 'person1') {
                // 重新选择被交接人，如果交接人发生变化，且生效审批模版有数据，需要清空
                if( this.form.person1 && this.form.person1 != newPersonId && this.form.templateIds.length>0){
                    this.form.templateIds = []
                    this.approvalFormsIds = []
                    this.approvalFlowsIds = []
                    this.templateNames = ''
                    this.$message({
                        message: '更换被交接人，请重新选择生效模版。',
                        type: 'warning'
                    });
                }
                this.person1 = data;
                this.form.person1 = newPersonId
                this.$refs.form.validateField('person1')
                this.form.person2 && this.$refs.form.validateField('person2')
                
            } else if (this.personType === 'person2') {
               this.person2 = data
               this.form.person2 = newPersonId
               this.$refs.form.validateField('person2')
            }
            console.log('>>',this.form)
        },
        fetchData() {
            const params = {
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize
            }
            this.$api.workflowTransferList(params).then((res) => {
                if (res.code === 0) {
                    this.tableList = res.data.list
                    this.page.totalNum = res.data.totalNum
                }else{
                    this.tableList = []
                    this.page.totalNum = 0
                }
            }).catch((err) => {
                console.log(err)
            })
        },
        handleCurrentChange(currentChange) {
            this.page.pageNo = currentChange
            this.fetchData()
        },
        handleSizeChange(sizeChange) {
            this.page.pageSize = sizeChange
            this.fetchData()
        },


        openAdiog() {
            this.dialogFormVisible = true;
            this.form = {
                person1: "",
                person2: "",
                templateIds: []
            };
            this.person1 = []
            this.person2 = []
            this.approvalFormsIds = []
            this.approvalFlowsIds = []
            this.templateNames = ''
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });
        },
        currentForms(data, checked, ){
            console.log(data, checked,);
        },
        //确认审批单
        update(){
            // 处理审批单
            this.approvalFormsIds = this.$refs.approvalFormsTree.getCheckedKeys();
            let checkedFormsNode = this.$refs.approvalFormsTree.getCheckedNodes()
            checkedFormsNode = checkedFormsNode.filter(e=>e.groupName)
            
            // 处理审批流
            this.approvalFlowsIds = this.$refs.approvalFlowsTree.getCheckedKeys();
            let checkedFlowsNode = this.$refs.approvalFlowsTree.getCheckedNodes()
            checkedFlowsNode = checkedFlowsNode.filter(e=>e.groupName)
            console.log(this.approvalFlowsIds,checkedFlowsNode);

            // 处理两个
            let allCheckedNode = [...checkedFormsNode,...checkedFlowsNode]
            this.templateNames = this.makeFormsNames(allCheckedNode)
            // console.log(checkedNode,this.templateNames); 
            
            this.form.templateIds = allCheckedNode.map(e=>e.id)
            this.dialogFlowVisible = false
        },
        makeFormsNames(list){
            const groups = new Map()
            list.forEach(item => {
                if (!groups.has(item.groupName)) {
                    groups.set(item.groupName, []);
                }
                groups.get(item.groupName).push(item.label);
            });
            const resultParts = [];
            groups.forEach((names, groupName) => {
                const namesStr = names.join(',');
                resultParts.push(`${groupName}(${namesStr})`);
            });
            return resultParts.join(';');
        },
        //确认新增
        subForm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.btnloading = true;
                    // 被交接人 formUser 交接人 toUser
                    let postData = {
                        fromUserId:this.form.person1,
                        toUserId:this.form.person2,
                        templateIds:this.form.templateIds

                    }
                    console.log('>>',postData)
                    this.$api.workflowTransferAdd(postData).then((res) => {
                    if (res.code === 0) {
                        this.page.pageNo = 1
                        this.dialogFormVisible = false
                        this.fetchData()
                    }
                }).finally(() => {
                    
                    this.btnloading = false
                    
                })
                }
            })

        },
    }
}
</script>

<style scoped lang="scss">
.data-title {
    width: 100%;
    height: 32px;
    margin-top: 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title-line {
        width: 2px;
        height: 16px;
        background: #00B498;
        border-radius: 0px 0px 0px 0px;
        margin-top: 8px;
    }

    .title-name {
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 16px;
        color: #2F3030;
        margin-left: 4px;
        line-height: 32px;
    }

    .title-btn {
        display: flex;

        .title-btn-item {
            width: 110px;
            height: 32px;
            background: #FFFFFF;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #E3E6E5;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-left: 8px;
            padding-right: 8px;
            box-sizing: border-box;
            cursor: pointer;

            .btn-l {
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #2F3030;

            }
        }


    }
}


.content {
    padding: 32px 16px 16px;
    background-color: #ffffff;
    min-height: calc(100vh - 118px);
    box-sizing: border-box;
    border-bottom: 32px solid #F5FAF9;
    border-radius: 8px 8px 8px 8px / 8px 8px 40px 40px;

    h3 {
        position: relative;
        margin-bottom: 20px;
        padding-left: 10px;

        &:before {
            position: absolute;
            top: 5px;
            left: 0;
            display: inline-block;
            content: "";
            width: 3px;
            height: 20px;
            background-color: #00B498;
        }
    }

    h4 {
        padding-top: 10px;
        border-top: 1px solid #bbbbbb;
    }
}
.elForm {
    padding: 20px 10px;
    /deep/{
        .el-input__inner,
        .el-textarea__inner{ 
            padding-left: 8px;
        }
        .el-form-item__label{
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
        }
    }
    
}
.pop-handover{
    .tips{
        font-size: 13px;
        line-height: 1.4;
        color: #939696;
    }
    /deep/{
        .el-dialog__body{
            padding-bottom: 0;
            padding-top: 0;
        }
        .el-form-item__label{
            padding-bottom: 0;
        }
        .el-tag__close{
            display: none;
        }
        .el-dialog__footer{
            padding-bottom: 30px;
        }
        .el-upload-list__item{
            transition: none;
        }
    }
}
// 模版弹窗
.flow-form{
    display: flex;
    margin:0 20px 20px;
    
    border: 1px solid #ececec;
    .flow-1,
    .flow-2{
        flex: 1;
       
        width: 50%;
        box-sizing: border-box;
        padding: 10px;
        padding-right: 20px;
    }
    .flow-1{
        border-right: 1px solid #ececec;
    }
    .flow-head{
        font-size: 16px;
        font-weight: bold;
        color: #333;
        margin-bottom: 10px;
        padding-left: 6px;
        position: relative;
        &::after {
                content: '';
                position: absolute;
                left: 0;
                top: 4px;
                width: 2px;
                height: 16px;
                background: #00B498;
            }
    }
    .flow-list{
        height: 500px;
        overflow-y: auto;
        .group-name{
            font-size: 14px;
            font-weight: bold;
             margin-bottom: 8px;
            padding-left: 20px;
            color: #333;
            box-sizing: border-box;
        }
        .group-con{
            padding-left: 40px;
            font-size: 14px;
            margin-bottom: 10px;
            .item-name{
                display: block;
                margin-bottom: 4px;
            }
        }
    }
    .flow-tree{
        height: 500px;

        overflow-y: auto;
        
    }
}
.flow-form-add{
    .flow-1,
    .flow-2{
        padding-right: 0;
        padding-bottom: 0;
    }
    .flow-tree{
        /deep/{
            .el-tree-node__label{
                font-weight: bold;
                color: #333;
                font-size: 14px;
            }
        .el-tree-node__children {
            .el-tree-node__content{
                cursor: default;
                background-color: #FFF!important;
                // &:hover{
                //     background-color: #FFFFFF;
                // }
            }
            .el-tree-node__label{
                font-weight: normal;
                color: #606266;
                cursor: default;
            }
            }
        }
    }
}
.select-all{
    width: 100%;
}
.select-wrap{
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    display: flex;
    min-height: 36px;
    // line-height: 36px;
    box-sizing: border-box;
    padding: 9px 30px 7px 6px;
    position: relative;
    cursor: pointer;
    &:hover{
        border-color: #E3E6E5;
    }
    .select-names{
        line-height: 20px;
        font-size: 14px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 5; /* 这里设置行数 */
        overflow: hidden;
        text-align: left;
    }
    .icon-down{
        position: absolute;
        right: 4px;
        top: 0;
        width: 25px;
        height: 36px;
        color: #C0C4CC;
    }
}
</style>